import { render } from "./SmallCircleButton.vue?vue&type=template&id=6687431c&scoped=true"
import script from "./SmallCircleButton.vue?vue&type=script&lang=js"
export * from "./SmallCircleButton.vue?vue&type=script&lang=js"

import "./SmallCircleButton.vue?vue&type=style&index=0&id=6687431c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6687431c"],['__file',"src/components/button/SmallCircleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6687431c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6687431c', __exports__)) {
    console.log('reload')
    api.reload('6687431c', __exports__)
  }
  
  module.hot.accept("./SmallCircleButton.vue?vue&type=template&id=6687431c&scoped=true", () => {
    console.log('re-render')
    api.rerender('6687431c', render)
  })

}


export default __exports__